// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__PlYzJ","inner":"Footer_inner__3BDaC","nextIcon":"Footer_nextIcon__-ZthR","innerLeft":"Footer_innerLeft__2aXb4"};